import React from 'react';

import * as Cell from '../common/Cell.jsx';
import { Animation } from '../common/Container.jsx';
import Token from '../common/Token.jsx';

function RepresentativeCellContainer(props) {
    let content = <Cell.Container {...props} className="cell--whitelabel--representative" useCellSpacer={false} />;
    switch (props.animation) {
        case '1':
            content = <Animation builder={props.builder}>{content}</Animation>
            break;
    }
    return content;
}

function RepresentativeMetaComponent(props) {
    const handleTokenReplacement = (keyword, options) => {
        const data = props.data || {};
        let replaceString = '';
        switch (keyword) {
            case Token.CompanyName:
                if (data.company && data.company.length > 0) {
                    replaceString = Token.getReplacementString(data.company, options);
                }
                break;
            case Token.Address.City:
                if (data.city && data.city.length > 0) {
                    replaceString = Token.getReplacementString(data.city, options);
                }
                break;
            case Token.Address.Line1:
                if (data.addressLineOne && data.addressLineOne.length > 0) {
                    replaceString = Token.getReplacementString(data.addressLineOne, options);
                }
                break;
            case Token.Address.Line2:
                if (data.addressLineTwo && data.addressLineTwo.length > 0) {
                    replaceString = Token.getReplacementString(data.addressLineTwo, options);
                }
                break;
            case Token.Address.State:
                if (data.state && data.state.length > 0) {
                    replaceString = Token.getReplacementString(data.state, options);
                }
                break;
            case Token.Address.Zip:
                if (data.zip && data.zip.length > 0) {
                    replaceString = Token.getReplacementString(data.zip, options);
                }
                break;
            case Token.Phone:
                if (data.phone && data.phone.length > 0) {
                    replaceString = `<a href='tel:${data.phone}'>${Token.getReplacementString(data.phone, options)}</a>`;
                }
                break;
            case Token.Website:
                if (options && options.display && options.display.length > 0 && data.website && data.website.length > 0) {
                    let link = data.website;
                    if (!link.startsWith('http')) {
                        link = `http://${link}`;
                    }
                    replaceString = `<a href='${link}' target='_blank'>${options.display}</a>`;
                }
                break;
            default:
                replaceString = undefined;
                break;
        }
        return replaceString;
    }
    return <Cell.Meta {...props} parseConditions={[props.data.company]} onTokenReplacement={handleTokenReplacement} />
}
const RepresentativeMetaTokens = () => {
    return [
        Token.getWrappedTokenConfig('Company Name', Token.CompanyName),
        Token.getWrappedTokenConfig('Address Line 1', Token.Address.Line1),
        Token.getWrappedTokenConfig('Address Line 2', Token.Address.Line2),
        Token.getWrappedTokenConfig('City', Token.Address.City),
        Token.getWrappedTokenConfig('State', Token.Address.State),
        Token.getWrappedTokenConfig('Zip', Token.Address.Zip),
        Token.getWrappedTokenConfig('Phone Number', Token.Phone),
        {
            display: 'Website',
            options: [{ display: 'Display Text', name: 'display' }],
            token: Token.Website
        }
    ];
}
const RepresentativeMeta = { Component: RepresentativeMetaComponent, Tokens: RepresentativeMetaTokens };

export {
    RepresentativeCellContainer,
    RepresentativeMeta
}